import { render } from "./PaymentRegister.vue?vue&type=template&id=7f92c57a"
import script from "./PaymentRegister.vue?vue&type=script&lang=js"
export * from "./PaymentRegister.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Desktop/projects/Realgestion/rg-massive-camoruco/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__